
<div class="UPLOADCOMPONENT">
  <div class="modal-header text-center">
    <h2 id="hdrImageTitle" class="modal-title" style="color: grey;font-size:25px;margin-top: 10px;">Upload</h2>
    <div class="d-flex flex-column align-items-end">
      <button type="button" mat-raised-button class="sample-download ml-auto" (click)="downloadSample()">
        {{ 'Download sample data' }}
      </button>
    </div>
    <!--<button type="button" style="color: black;" title="Close" class="close float-right" data-dismiss="modal" aria-label="Close" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>-->
</div>

<mat-dialog-content>
  <div class="mb-4">
    <div>
      <ul class="mb-0" style="list-style: none; font-size: 18px;color: grey;line-height: 30px;letter-spacing: 1px ;">
        <li><strong>Maximum File Size:</strong>&nbsp;&nbsp;&nbsp;&nbsp;<span>5MB</span></li>
        <li>
          <strong>Acceptable formats: &nbsp;&nbsp;</strong>
          <span style="font-weight: 500;">.XLS or .XLSX&nbsp;(Excel Files)</span>
        </li>
      </ul>
    </div>
  </div>
  <div
    class="container"
    style="text-align: center"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <h2 style="color: grey;font-size: 16px;">Drag and drop file here</h2>
    <div (click)="fileDropRef.click()"
      style="border: 1px dashed #979797;width: 100%;max-width: 450px;height: 120px;align-items: center;justify-content: center;margin: 0 auto;display: flex;border-radius: 20px;padding-top: 20px;background-color: #E9ECEE; cursor: pointer;">
      <input type="file" #fileDropRef id="fileDropRef" style="display: none;"
        (click)="$event.stopPropagation()"
        (change)="fileBrowseHandler($event.target.files)"
        [disabled]="files.length" accept=".xls,.xlsx" />
        <div class="white-icon"
          style="font-size:26px;color:grey;transform: scale(2); margin-bottom: 40px;margin-top:10px">
          <i class="fa-solid fa-arrow-up-from-bracket"></i>
        </div>
      </div>
      <!--<mat-icon class="white-icon" matTooltip="Upload excel"
    style="transform: scale(2); margin-bottom: 10px">cloud_upload</mat-icon>-->
    <!--<br />
    <br />
    <h4>or</h4>
    <br />-->
    <div style="margin-top: 20px;">
      <button (click)="fileDropRef.click()"
        style="background-color: white; color: grey; padding: 6px 12px; border-radius: 4px; border: 1px solid grey; cursor: pointer;border-radius: 12px;font-size: 20px;letter-spacing: 1px;">
        Browse for File
      </button>
    </div>

  </div>
  <div class="files-list">
    @for (file of files; track file; let i = $index) {
      <div class="single-file">
        <div class="file-icon" style="width: 30px; font-size: 100px">
          <mat-icon> attach_file</mat-icon>
        </div>
        <div class="info">
          <h4 class="name">
            {{ file?.name }}
          </h4>
          <p class="size">
            {{ formatBytes(file?.size) }}
          </p>
          <div class="progress-cont">
            <div class="progress" [style.width]="file?.progress + '%'"
            [ngStyle]="{'background-color': errorList?.length ? '#ff0000': '#22c95cfa'}"></div>
          </div>
        </div>
        <!-- <div class="delete" (click)="deleteFile(i)">
        <mat-icon>delete_forever</mat-icon>
      </div> -->
    </div>
  }
</div>
@if (errorList.length && fileStatus === 'Error') {
  <div class="d-flex justify-content-end mr-3">
    <button type="button" (click)="downloadLogs()">Download error logs</button>
  </div>
}
@if (files.length) {
  <div class="logger" #scrollLogs>
    @if (uploading) {
      <div>Uploading file {{processingFile}}...</div>
    }
    @if (validating) {
      <div>Validating...</div>
    }
    @if (uploaded || errorList.length) {
      <div>Processing time: {{counter}}s</div>
    }
    @if (errorList.length) {
      <div>
        <div class="error-list"><u>Errors:</u></div>
        <ol class="errors">
          @for (item of errorList; track item) {
            <li>
              {{item}}
            </li>
          }
        </ol>
      </div>
    }
    @if (errorList.length && uploaded) {
      <div>Please fix the errors and try uploading again.</div>
    }
    @if (!errorList.length && uploaded) {
      <div>File validation successful! File is ready to upload.</div>
    }
  </div>
}
<button type="submit" mat-raised-button class="upload-button"
  [disabled]="!files.length || processing || !uploaded || errorList.length > 0"
  (click)="uploadFile()">
  @if (showProgress) {
    <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"
    [diameter]="30"></mat-progress-spinner>
  }
  @if (!showProgress) {
    <span>Upload file</span>
  }
</button>
</mat-dialog-content>
</div>
